/* ================================================
   RefinementDrawer - 二次编辑微调抽屉样式
   ================================================ */

/* 仅用于承载开场动画，不遮暗或模糊左侧预览 */
.refine-backdrop {
  position: fixed;
  inset: 0;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  z-index: 105000;
  pointer-events: none; /* 背景不拦截左侧点击，让用户感知对比 */
  animation: backdropFadeIn 0.3s ease forwards;
}

@keyframes backdropFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* 抽屉主体 */
.refine-drawer {
  position: fixed;
  top: var(--vv-top, 0);
  right: 0;
  bottom: 0;
  width: 48%;
  min-width: 320px;
  max-width: 820px;
  height: 100%;
  height: var(--vv-height, 100dvh);
  max-height: var(--vv-height, 100dvh);
  z-index: 105001;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #0d1117 0%, #0a0e16 100%);
  border-left: 1px solid #d3e3fd;
  box-shadow: -8px 0 40px rgba(0, 0, 0, 0.6), -2px 0 20px rgba(0, 170, 255, 0.08);
  transform: translateX(100%);
  transition: transform 0.38s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-sizing: border-box;
}

.refine-drawer.open {
  transform: translateX(0);
}

/* ── 头部 ─────────────────────────────────────── */
.refine-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  padding-top: max(14px, env(safe-area-inset-top));
  padding-right: max(20px, env(safe-area-inset-right));
  background: linear-gradient(90deg, rgba(0, 170, 255, 0.08), transparent);
  border-bottom: 1px solid rgba(26, 115, 232, 0.1);
  flex-shrink: 0;
}

.refine-drawer-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #e0e8ff;
}

.refine-drawer-title i {
  font-size: 20px;
  color: #1a73e8;
  filter: none;
}

.refine-drawer-subtitle {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.45);
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  padding-left: 10px;
  margin-left: 2px;
}

.refine-close-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.refine-close-btn:hover:not(:disabled) {
  background: rgba(255, 80, 80, 0.15);
  border-color: rgba(255, 80, 80, 0.4);
  color: #ff6b6b;
}

.refine-close-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── 主体（可滚动） ────────────────────────────── */
.refine-drawer-body {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.refine-drawer-body::-webkit-scrollbar {
  width: 4px;
}

.refine-drawer-body::-webkit-scrollbar-track {
  background: transparent;
}

.refine-drawer-body::-webkit-scrollbar-thumb {
  background: rgba(26, 115, 232, 0.14);
  border-radius: 4px;
}

/* ── 预览区 ───────────────────────────────────── */
.refine-preview-section {
  padding: 14px 16px 20px;
  animation: slideUp 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

.refine-preview-label {
  font-size: 12px;
  font-weight: 600;
  color: #1a73e8;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.refine-result-preview {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(26, 115, 232, 0.14);
  background: rgba(0, 10, 25, 0.6);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  min-height: 240px;
  max-height: 420px;
  position: relative;
}

.refine-iframe-preview {
  min-height: 300px;
}

.refine-iframe {
  width: 100%;
  height: 380px;
  border: none;
  display: block;
}

.refine-code-preview {
  max-height: 260px;
  overflow-y: auto;
}

.refine-geogebra-preview {
  min-height: 380px;
  max-height: 460px;
}

.refine-code-block {
  margin: 0;
  padding: 16px;
  font-size: 11px;
  font-family: "Fira Code", "Consolas", monospace;
  color: rgba(0, 200, 100, 0.9);
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
}

/* ── 对话历史 ─────────────────────────────────── */
.refine-chat-history {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.refine-chat-empty {
  margin: auto;
  text-align: center;
  color: rgba(255, 255, 255, 0.35);
  padding: 40px 20px;
}

.refine-chat-empty i {
  font-size: 36px;
  color: #d3e3fd;
  display: block;
  margin-bottom: 12px;
}

.refine-chat-empty p {
  margin: 0 0 6px;
  font-size: 14px;
}

.refine-chat-hint {
  font-size: 12px !important;
  color: rgba(255, 255, 255, 0.2) !important;
}

/* 消息气泡 */
.refine-message {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  animation: msgFadeIn 0.25s ease forwards;
}

@keyframes msgFadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.refine-message-user {
  flex-direction: row-reverse;
}

.refine-message-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
}

.refine-message-user .refine-message-avatar {
  background: #f0f4f9; border: 1px solid #d3e3fd;
  border: 1px solid #d3e3fd;
  color: #1a73e8;
}

.refine-message-assistant .refine-message-avatar {
  background: linear-gradient(135deg, rgba(100, 200, 100, 0.15), rgba(0, 150, 80, 0.2));
  border: 1px solid rgba(0, 180, 100, 0.25);
  color: #00cc66;
}

.refine-message-content {
  /* max-width: 80%;  <-- 移除这个限制，让wrapper控制 */
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 13.5px;
  line-height: 1.55;
  width: fit-content;
}

.refine-message-image {
  width: fit-content;
  max-width: min(260px, 100%);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #d3e3fd;
  background: rgba(0, 10, 25, 0.4);
}

.refine-message-image img {
  display: block;
  max-width: 100%;
  max-height: 220px;
  object-fit: contain;
}

.refine-message-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1; /* 占据剩余全部宽度，防止被短文本压缩 */
  min-width: 0; /* 防止内容溢出撑破flex */
  max-width: 90%; /* 稍微放宽一点最大宽度 */
}

.refine-result-container {
  width: 100%;
  margin-top: 4px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(26, 115, 232, 0.14);
  background: rgba(0, 10, 25, 0.4);
  animation: slideUp 0.3s ease forwards;
}

.refine-result-embedded {
  width: 100%;
  /* 移除全局 max-height，让各自的组件控制高度 */
  position: relative;
}

.refine-result-embedded .preview-content {
  min-height: 360px;
  border-radius: 12px;
}

.refine-result-embedded .video-player {
  min-height: 360px;
}

/* 针对不同类型的嵌入做微调 */
.refine-iframe-embedded {
  height: 450px; /* 修复3D模式嵌入没有高度的问题，增加高度 */
}

.refine-geogebra-embedded {
  height: 550px; /* 显著增加GGB的高度，避免被截断 */
}

.refine-message-user .refine-message-content-wrapper {
  align-items: flex-end;
}

.refine-message-assistant .refine-message-content-wrapper {
  align-items: flex-start;
}

.refine-message-user .refine-message-content {
  background: rgba(26, 115, 232, 0.1);
  border: 1px solid #d3e3fd;
  color: #d0e8ff;
  border-top-right-radius: 4px;
}

.refine-message-assistant .refine-message-content {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.09);
  color: rgba(255, 255, 255, 0.8);
  border-top-left-radius: 4px;
}

/* 生成中动画 */
.refine-loading-msg {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 140px;
  padding: 12px 16px;
}

.refine-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(0, 170, 255, 0.6);
  animation: dotBounce 1.2s infinite ease-in-out;
  flex-shrink: 0;
}

.refine-dot:nth-child(1) { animation-delay: 0s; }
.refine-dot:nth-child(2) { animation-delay: 0.2s; }
.refine-dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes dotBounce {
  0%, 80%, 100% { transform: scale(0.7); opacity: 0.5; }
  40%           { transform: scale(1.1); opacity: 1; }
}

.refine-loading-text {
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.5);
  margin-left: 4px;
  flex-shrink: 0;
}

/* ── 输入区 ───────────────────────────────────── */
.refine-input-area {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  padding: 12px 16px;
  padding-bottom: max(12px, env(safe-area-inset-bottom));
  padding-right: max(16px, env(safe-area-inset-right));
  padding-left: max(16px, env(safe-area-inset-left));
  border-top: 1px solid rgba(26, 115, 232, 0.08);
  background: rgba(0, 8, 20, 0.7);
  flex-shrink: 0 !important; /* 核心：绝不可被 flex 压缩，保证输入区完整可见 */
  box-sizing: border-box;
}

.refine-input-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.refine-input-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.refine-upload-btn {
  width: 42px;
  min-height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(26, 115, 232, 0.14);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  transition: all 0.2s ease;
}

.refine-upload-btn:hover:not(:disabled),
.refine-upload-btn.has-file {
  color: #1a73e8;
  border-color: #a8c7fa;
  background: rgba(26, 115, 232, 0.08);
}

.refine-upload-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refine-upload-btn i {
  font-size: 18px;
}

.refine-upload-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 6px;
  height: 6px;
  background: #1a73e8;
  border-radius: 50%;
  box-shadow: none;
}

.refine-image-preview {
  position: relative;
  width: fit-content;
  max-width: 260px;
  max-height: clamp(70px, 16vh, 150px);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #d3e3fd;
  background: rgba(0, 10, 25, 0.55);
}

.refine-image-preview img {
  display: block;
  max-width: 100%;
  max-height: clamp(70px, 16vh, 150px);
  object-fit: contain;
}

.refine-remove-image-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

.refine-remove-image-btn:hover:not(:disabled) {
  background: rgba(255, 80, 80, 0.75);
}

.refine-textarea {
  flex: 1;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(26, 115, 232, 0.14);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: #e0e8ff;
  resize: none;
  outline: none;
  font-family: inherit;
  line-height: 1.5;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  min-height: 46px;
  max-height: 110px;
  overflow-y: auto;
  box-sizing: border-box;
}

.refine-textarea::placeholder {
  color: rgba(255, 255, 255, 0.25);
  font-size: 13px;
}

.refine-textarea:focus {
  border-color: #a8c7fa;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.08);
}

.refine-textarea:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refine-send-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  background: #1a73e8;
  border: 1px solid #a8c7fa;
  border-radius: 10px;
  color: #fff;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;
  height: fit-content;
  align-self: flex-end;
  min-height: 42px;
}

.refine-send-btn:hover:not(:disabled) {
  background: #1557b0;
  box-shadow: 0 4px 15px rgba(0, 170, 255, 0.35);
  transform: translateY(-1px);
}

.refine-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.refine-send-btn i {
  font-size: 15px;
}

/* 旋转动画（用于loading状态） */
.rotating {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ── 片段选择条 ───────────────────────────────── */

.refine-segment-bar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 16px 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.15);
  flex-shrink: 0 !important;
}

.refine-segment-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 500;
  letter-spacing: 0.03em;
}

.refine-segment-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.refine-segment-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  white-space: nowrap;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.refine-segment-chip:hover:not(:disabled) {
  background: rgba(0, 190, 255, 0.12);
  border-color: rgba(0, 190, 255, 0.4);
  color: rgba(0, 210, 255, 0.9);
}

.refine-segment-chip.active {
  background: rgba(26, 115, 232, 0.12);
  border-color: rgba(0, 190, 255, 0.6);
  color: rgba(0, 220, 255, 1);
  font-weight: 600;
}

.refine-segment-chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.refine-segment-hint {
  font-size: 11px;
  color: rgba(0, 200, 255, 0.7);
  font-style: italic;
}

/* 片段选择卡片样式 */
.refine-segment-cards {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 8px 4px;
  scroll-behavior: smooth;
}

.refine-segment-cards::-webkit-scrollbar {
  height: 4px;
}

.refine-segment-cards::-webkit-scrollbar-track {
  background: transparent;
}

.refine-segment-cards::-webkit-scrollbar-thumb {
  background: rgba(26, 115, 232, 0.14);
  border-radius: 4px;
}

/* 单个片段卡片 */
.refine-segment-card {
  flex: 0 0 120px;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.refine-segment-card:hover:not(.disabled) {
  border-color: #a8c7fa;
  background: rgba(0, 170, 255, 0.05);
  transform: translateY(-2px);
}

.refine-segment-card.active {
  border-color: #1a73e8;
  background: rgba(26, 115, 232, 0.08);
  box-shadow: none;
}

.refine-segment-card.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refine-segment-card.failed {
  border-color: rgba(255, 82, 82, 0.65);
  background: rgba(255, 82, 82, 0.08);
}

.refine-segment-card.failed .refine-segment-card-preview-placeholder,
.refine-segment-card.failed .refine-segment-card-desc {
  color: #ff6b6b;
}

/* 预览区域 */
.refine-segment-card-preview {
  position: relative;
  width: 100%;
  height: 68px;
  background: #000;
  overflow: hidden;
}

.refine-segment-video-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.refine-segment-card-preview-placeholder {
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  color: rgba(255, 255, 255, 0.25);
}

.refine-segment-card-preview-placeholder i {
  font-size: 24px;
}

/* 角标 */
.refine-segment-card-badge {
  position: absolute;
  top: 4px;
  left: 6px;
  background: rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 4px;
  line-height: 1;
  z-index: 2;
}

/* 卡片信息 */
.refine-segment-card-info {
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.refine-segment-card-title {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.refine-segment-card-all .refine-segment-card-preview-placeholder {
  height: 68px;
  background: #e8f0fe;
  color: #1a73e8;
}

.refine-segment-card-all .refine-segment-card-title {
  font-weight: 600;
  color: #1a73e8;
}

.refine-segment-card-desc {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.35);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── 响应式 ───────────────────────────────────── */
@media (max-width: 900px) {
  .refine-backdrop {
    pointer-events: auto !important;
    background: rgba(0, 0, 0, 0.45) !important;
    backdrop-filter: blur(4px) !important;
    -webkit-backdrop-filter: blur(4px) !important;
    cursor: pointer;
  }

  .refine-drawer {
    width: min(580px, 100%) !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-shadow: -4px 0 30px rgba(0, 0, 0, 0.5) !important;
  }
}

@media (max-width: 600px) {
  .refine-drawer {
    width: 100% !important;
    border-radius: 0 !important;
  }

  .refine-drawer-subtitle {
    display: none;
  }
}

/* 针对折叠屏横屏、矮屏幕或软键盘极高状态的紧凑适配 */
@media (max-height: 640px) {
  .refine-drawer-header {
    padding: 8px 14px;
    padding-top: max(8px, env(safe-area-inset-top));
  }
  .refine-drawer-title {
    font-size: 14px;
  }
  .refine-drawer-title i {
    font-size: 16px;
  }
  .refine-drawer-subtitle {
    display: none;
  }
  .refine-close-btn {
    width: 28px;
    height: 28px;
  }
  .refine-segment-bar {
    padding: 4px 10px 3px;
    gap: 3px;
  }
  .refine-segment-cards {
    padding: 3px 0;
    gap: 8px;
  }
  .refine-segment-card {
    flex: 0 0 96px;
  }
  .refine-segment-card-preview,
  .refine-segment-card-preview-placeholder {
    height: 44px;
  }
  .refine-segment-card-info {
    padding: 3px 6px;
  }
  .refine-image-preview {
    max-height: 80px;
  }
  .refine-image-preview img {
    max-height: 80px;
  }
  .refine-input-area {
    padding: 6px 12px;
    padding-bottom: max(6px, env(safe-area-inset-bottom));
  }
  .refine-textarea {
    min-height: 38px;
    max-height: 70px;
    padding: 6px 10px;
    font-size: 13px;
  }
  .refine-upload-btn,
  .refine-send-btn {
    min-height: 38px;
    height: 38px;
    padding: 6px 12px;
  }
}

@media (min-width: 901px) {
  html[data-theme='light'] .refine-backdrop {
    background: transparent !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
  }
}
@media (max-width: 900px) {
  html[data-theme='light'] .refine-backdrop {
    background: rgba(0, 0, 0, 0.4) !important;
    pointer-events: auto !important;
    cursor: pointer;
  }
}
html[data-theme='light'] .refine-drawer {
  color: var(--hm-ink) !important; background: rgba(255,255,255,.98) !important;
  border: 0 !important; border-left: 1px solid #dce3ec !important;
  border-radius: 22px 0 0 22px !important; box-shadow: -16px 0 48px rgba(37,55,84,.16) !important;
}
html[data-theme='light'] .refine-drawer-header {
  color: var(--hm-ink) !important; background: #fff !important; border-color: #e7ebf1 !important;
}
html[data-theme='light'] .refine-drawer-title { color: var(--hm-ink) !important; text-shadow: none !important; }
html[data-theme='light'] .refine-drawer-subtitle,
html[data-theme='light'] .refine-chat-hint { color: var(--hm-muted) !important; }
html[data-theme='light'] .refine-chat-empty,
html[data-theme='light'] .refine-input-area,
html[data-theme='light'] .refine-result-container,
html[data-theme='light'] .refine-segment-card {
  color: var(--hm-ink) !important; background: #f8fafd !important;
  border: 1px solid #e1e7ef !important; border-radius: 14px !important; box-shadow: none !important;
}
html[data-theme='light'] .refine-segment-card:hover {
  background: #fff !important; border-color: #b9cde8 !important; box-shadow: var(--hm-shadow-sm) !important;
}
html[data-theme='light'] .refine-segment-card.active {
  background: #eef5ff !important; border-color: #8eb6eb !important;
  box-shadow: 0 0 0 3px rgba(26,115,232,.08) !important;
}
html[data-theme='light'] .refine-segment-card-title { color: var(--hm-ink) !important; }
html[data-theme='light'] .refine-segment-card-desc { color: #77818c !important; }
html[data-theme='light'] .refine-textarea {
  color: var(--hm-ink) !important; background: #fff !important;
  border: 1px solid #cfd9e6 !important; border-radius: 11px !important; box-shadow: none !important;
}
html[data-theme='light'] .refine-close-btn,
html[data-theme='light'] .refine-upload-btn {
  color: #4f5965 !important; background: #fff !important;
  border: 1px solid #d8e1ec !important; border-radius: 11px !important;
}
html[data-theme='light'] .refine-send-btn {
  color: #fff !important; background: var(--hm-blue) !important;
  border-color: var(--hm-blue) !important; border-radius: 11px !important;
  box-shadow: 0 8px 20px rgba(26,115,232,.18) !important;
}
html[data-theme='light'] .refine-message-assistant {
  color: #38424e !important; background: #f3f6fa !important; border-color: #e0e6ee !important;
}
html[data-theme='light'] .refine-message-user {
  color: #fff !important; background: var(--hm-blue) !important; border-color: var(--hm-blue) !important;
}
